import { useQuery } from '@tanstack/react-query';

import { getBusinessList } from '~/services/BusinessTraveller/BusinessTravellerService';

type BusinessStatus = 'active' | 'deactivated';

export const businessListQueryKeys = {
  all: ['businesses'],
  lists: () => [...businessListQueryKeys.all, 'list'],
  list: (filters: {
    status: BusinessStatus;
    page: number;
    pageSize: number;
    nameString?: string;
    businessId?: string;
  }) => [...businessListQueryKeys.lists(), filters],
};

interface UseGetBusinessesParams {
  status: BusinessStatus;
  page: number;
  pageSize: number;
  nameString?: string;
  businessId?: string;
}

export function useGetBusinesses({ status, page, pageSize, nameString, businessId }: UseGetBusinessesParams) {
  return useQuery({
    queryKey: businessListQueryKeys.list({ status, page, pageSize, nameString, businessId }),
    queryFn: () => getBusinessList(pageSize, page, nameString, businessId, status),
  });
}
